import config from '@/config';
import router from '@/router';

const counts = ref({
  employees: 0,
  punchIn: 0,
  lastmonthemployee:0,
  totalActiveSites: 0,
  activeSiteLast30days: 0,
  totalPendingTasks: 0,
  totalAssignedTasks: 0,
  totalPendingTasks30Days: 0,
  totalAssignedTasks30Days: 0,
  myPresentDaysOfCurrentMonth: 0,
  myAbsentDaysOfCurrentMonth: 0,
});
export function useCommon() {
  const edit = (data:any) =>  router.push({ name: data.name, params: {...data.params} });
  const api = useAxios();
  const dashboardApi = dashboard(api);


  async function getCounts() {
    const res = await dashboardApi.getCounts();
    if (res.status === config.status.success) {
      counts.value.employees = res.data.counts.TotalEmployees
      counts.value.punchIn = res.data.counts.TotalTodaysPunches
      counts.value.lastmonthemployee = res.data.counts.LastMonthEmployee
      counts.value.totalActiveSites = res.data.counts.TotalSiteLocations
      counts.value.activeSiteLast30days = res.data.counts.TotalSiteLocationsLat30days
      counts.value.totalPendingTasks = res.data.counts.TotalPendingTasks ?? 0
      counts.value.totalAssignedTasks = res.data.counts.TotalAssignedTasks ?? 0
      counts.value.totalPendingTasks30Days = res.data.counts.TotalPendingTasks30Days ?? 0
      counts.value.totalAssignedTasks30Days = res.data.counts.TotalAssignedTasks30Days ?? 0
      counts.value.myPresentDaysOfCurrentMonth = res.data.counts.MyPresentDaysOfCurrentMonth ?? 0
      counts.value.myAbsentDaysOfCurrentMonth = res.data.counts.MyAbsentDaysOfCurrentMonth ?? 0
    }
  }
  return { edit, getCounts, counts };
}
